export default {
  cName: "Tenant Platform",
  last24hours: "24 Jam Terakhir",
  last7days: "7 Hari Terakhir",
  last30days: "30 Hari Terakhir",
  custom: "Kustom",
  multiple: "Banyak Pilihan",
  exportEdit: "Ekspor",
  getCode: "Dapatkan Kode Verifikasi",
  enterPhoneFormat: "Masukkan nomor telepon yang benar",
  sentSuccessfully: "Berhasil Terkirim",
  resend: "Kirim Ulang",
  setPower: "Mengatur Daya",
  powerPl: "Silakan Masukkan Daya",
  successfullySet: "Berhasil Diatur",
  rechargeSuccess: "Berhasil Diisi Ulang",
  sysTitle: "Platform Tenant",
  operatorId: "Kode Operator",
  oprName: "Nama Operator",
  tips: "Tips",
  isDelete: "Apakah anda yakin ingin menghapusnya?",
  deleteSuccess: "Berhasil Dihapus",
  updateSuccess: "Berhasil Diperbarui",
  addSuccess: "Berhasil Ditambahkan",
  all: "Semua",
  operation: "Operasi",
  dl: "Daya listrik yang dibebankan (kwh)",
  eleFee: "Biaya Listrik",
  serverFee: "Biaya Layanan",
  delayFee: "Biaya Kelebihan Waktu",
  totalAmount: "Jumlah Total",
  yuan: "Idr",
  kWh: "Kwh",
  unitOrder: "Unit",
  ac: "AC",
  dc: "DC",
  confirm: "Konfirmasi",
  noData: "Tidak Ada Data",
  allCity: "Semua Kota",
  chargingStation: "Stasiun Pengisian Daya",
  merchant: "Tenant",
  operator: "Operator",
  chargingPile: "Tumpukan Pengisian Daya",
  year: "Tahun",
  month: "Bulan",
  day: "Hari",
  timeType: "Jenis",
  regularText: "Normal",
  irregular: "Tidak Normal",
  operationSucess: "Berhasil",
  saveSucess: "Berhasil Disimpan",
  exportSuccess: "Berhasil Diimpor",
  allSelect: "Pilih Semua",
  toExamine: "Ulasan",
  invalid: "Buang",
  accountBalance: "Saldo Rekening",
  today: "Hari Ini",
  thisWeek: "Minggu Ini",
  thisMouth: "Bulan Ini",
  last5Year: "5 Tahun Terakhir",
  regular: {
    name: "Nama",
    please: "Silakan Masukan ",
    max: " tidak lebih dari ",
    maxText: " Karakter",
    min: "Tidak Kurang Dari",
    numberABC: "Hanya dapat terdiri dari angka atau huruf",
    number_ABC: "Hanya dapat terdiri dari angka, huruf, dan garis bawah",
    tel: "Masukkan nomor ponsel atau nomor telepon, 6-15 digit",
    phone: "Silakan masukkan nomor telepon",
    phonePl: "Silakan masukkan nomor ponsel",
    phonePl11: "Masukkan 11 digit nomor ponsel",
    phoneError: "Masukkan nomor ponsel yang benar",
    int: "Hanya bisa berupa bilangan bulat",
    maxInput: "Masukan Maksimum",
    minInput: "Masukan Minimum",
    unit: "",
    maxNum: "Tidak boleh lebih besar dari",
    minNum: "Tidak boleh kurang dari",
    money: "Jumlah Uang",
    towDecimal: "Simpan hingga dua angka desimal",
    email: "Silakan Masukkan Email",
    emailPl: "Kotak surat tidak boleh melebihi",
    emailError: "Harap isi email yang benar",
    passwordTips1: "Character limit: 12 to 18 characters",
    passwordTips2:
      "Harus mencakup huruf besar, huruf kecil, angka, dan karakter khusus: '!', '#', '$', '%', '&'."
  },
  unitText: {
    pen: "",
    yuan: "Idr",
    hours: "Jam",
    people: "Orang",
    seat: "Kursi",
    k: "K",
    kYuan: "K Idr",
    kKWh: "K Kwh",
    kKW: "K Kw",
    year: "Tahun",
    month: "Bulan",
    day: "Hari",
    ton: "Ton",
    second: "Kali",
    full: "Melebihi",
    reduce: "Mengurangi",
    give: "Memberikan",
    zhang: "Unit",
    individual: "Unit"
  },
  formText: {
    startTime: "Waktu Mulai",
    endTime: "Akhir Zaman",
    export: "Ekspor",
    exportLoading: "Mengekspor...",
    exportNumber: "Entri Yang Diekspor",
    exportPl: "Jumlah entri yang diekspor harus lebih besar dari 0",
    exportError: "Kesalahan ekspor atau batas waktu",
    allCity: "Semua Kota",
    selectGun: "Konektor Pengisi Daya",
    selectMch: "Tenant",
    selectSite: "Stasiun",
    selectPile: "Charger No.",
    selectTime: "Pilih Waktu",
    selectTimePl: "Silakan Pilih Waktu",
    selectOper: "Operator",
    downloadForm: "Unduh Formulir",
    intTips: "Nilai",
    beginTimeTips: "Pilih Waktu Mulai",
    endTimeTips: "Pilih Waktu Akhir",
    import: "Impor",
    selectProvince: "Silakan Pilih Provinsi",
    selectCity: "Silakan Pilih Kota",
    selectArea: "Silakan Pilih Distrik",
    subSuccess: "Berhasil",
    goBack: "Kembali.",
    timeNull: "Silakan Pilih Waktu",
    timeMax: "Waktu mulai tidak boleh melebihi waktu akhir"
  },
  directCurrent: "DC",
  alternatingCurrent: "AC",
  gunStatus: "Status Konektor",
  gunStatusObj: {
    onLine: "Online",
    offLine: "Offline",
    free: "Available",
    connected: "Plugged In",
    charging: "Charging",
    full: " Completed",
    trouble: "Fault",
    disabled: "Dinonaktifkan",
    booked: "Dipesan"
  },
  search: "Pencarian",
  update: "Edit",
  add: "Menambahkan",
  delete: "Menghapus",
  close: "Tutup",
  save: "Simpan",
  refresh: "Muat Ulang",
  back: "Kembali.",
  export: "Ekspor",
  import: "Impor",
  submit: "Kirim",
  cancel: "Batal",
  details: "Detail",
  safePassword: {
    title: "Masukkan kata sandi operasi untuk mengonfirmasi tindakan ini",
    password: "Kata Sandi",
    noPassword: "Lupa Kata Sandi?",
    passwordPl: "Masukkan Kata Sandi"
  },
  login: {
    contentTitle: "Mengisi masa depan yang hijau",
    contentTitleSmall:
      "Akses ke platform terbuka, dan masuk ke ekologi interkoneksi dengan satu langkah",
    account: "Login Akun",
    userNamePl: "Masukkan Nama Pengguna",
    passwordPl: "Masukkan Kata Sandi",
    passwordMax: "Masukkan kata sandi dengan lebih dari 6 digit",
    userName: "Nama Pengguna",
    password: "Kata Sandi",
    login: "Masuk",
    accountTime: "Setelah",
    accountTime2:
      "Beberapa hari, akun akan kedaluwarsa dan anda tidak akan dapat masuk ke sistem",
    mchSys: "Platform Tenant",
    changeLangPl: "Silakan Pilih Bahasa"
  },
  home: {
    todayOrder: "Charging Order",
    todayDl: "Konsumsi Listrik (kwh)",
    todayRevenue: "Pendapatan hari ini (idr)",
    gunStatus: "Status Konektor Charger",
    mengisiData: "Mengisi Data",
    assetTitle: "Informasi Aset",
    siteNum: "Stasiun",
    pileNum: "Pengisi Daya",
    gunNum: "Konektor",
    dcNum: "DC",
    acNum: "AC",
    totalPower: "Total Power (kw)",
    dcPower: "DC Power(kw)",
    acPower: "AC Power(kw)",
    settlementTitle: "Penyelesaian",
    dailyDtatement: "Laporan harian yang belum diselesaikan",
    withdrawalForm: "Perintah penarikan yang belum dibayar",
    undrawnAmount: "Jumlah Yang Dibayarkan",
    withdrawnAmount: "Jumlah Yang Dibayarkan",
    revenueTitle: "Pendapatan",
    totalRevenue: "Total Pendapatan (idr)",
    onlineChargingSharing: "Bagian pesanan online (idr)",
    offlineChargingSharing: "Bagian pesanan offline (idr)",
    chargingDurationRanking: "Peringkat Durasi Pengisian",
    totalChargingDuration: "Total waktu yang dikeluarkan",
    duration: "Durasi",
    chargingTimesRanking: "Peringkat Jumlah Pengisian",
    totalChargingTimes: "Total waktu pengisian daya",
    times: "Berapa Kali",
    pile: "Pengisi Daya",
    utilizationRate: "Tingkat Pemanfaatan",
    order: "Pesanan (unit)",
    total: "Total",
    hour: ":00"
  },
  nonCard: {
    cardMember: "Member Kartu",
    cardMemberStatis: "Status Kartu",
    memberTypeNum: "Jumlah Jenis Anggota",
    member: "Member",
    nonMember: "Non Member",
    use: "Sedang Digunakan",
    logOff: "Dihapus",
    recharged: "Diisi Ulang (idr)",
    charged: "Berbayar (idr)",
    globalSearch: "Nomor transaksi / nomor kartu",
    cardStatis: "Status Kartu",
    activation: "Active",
    unactivated: "Inactive",
    disabled: "Nonaktifkan",
    expired: "Kadaluarsa",
    normal: "Normal",
    logOffBtn: "Menghapus",
    delete: "Hapus",
    rechargedBtn: "Diisi Ulang",
    refundBtn: "Pengembalian Dana",
    operationRecord: "Catatan Operasi",
    capitalRecord: "Catatan Dana",
    thisYear: "Tahun Ini",
    accountPkId: "Card Serial Number",
    name: "Name",
    email: "E-mail",
    validity: "Masa Berlaku",
    cardPhysicalNumber: "Nomor Kartu",
    memberType: "Jenis",
    cardSerialNumber: "Nomor Kartu Fisik",
    silkScreenNumber: "Nomor Silk Screen",
    contactName: "Nama Kontak",
    phoneNo: "Telepon",
    accountBalance: "Saldo Kartu (idr)",
    cardStatus: "Status",
    createTime: "Waktu Pembukaan Kartu",
    cardPkId: "Nomor kartu by sistem",
    remarks: "Catatan",
    rechargeAmount: "Jumlah Isi Ulang",
    selectMemberType: "Pilih jenis keanggotaan kartu",
    NIK: "Nik",
    validPeriodSelection: "Masa Berlaku",
    chargingHours: "Charging Time",
    chargingHoursTip: "Waktu pengecasan yang diberikan dalam 1 hari",
    saveOnly: "Simpan Saja",
    keepAndActivate: "Simpan Dan Aktifkan",
    verCode: "Kode Verifikasi"
  },
  nonFundHistory: {
    rechargedTab: "Diisi Ulang",
    chargedTab: "Dibebankan",
    staName: "Nama Situs",
    chargeBeginTime: "Waktu Mulai",
    chargeEndTime: "Waktu Berakhir",
    chargeMinutes: "Waktu Pengisian Daya",
    chargeElect: "Daya listrik yang dibebankan (kwh)",
    delayAmount: "Biaya kelebihan waktu (idr)",
    delayDuration: "Durasi Penundaan",
    chargeAmount: "Jumlah pengisian daya (idr)",
    beforeBalance: "Saldo sebelum pembayaran (idr)",
    afterBalance: "Saldo setelah pembayaran (idr)",
    orderNo: "Nomor Pesanan",
    transactionTime: "Waktu Isi Ulang",
    rechargeAmount: "Jumlah (idr)",
    createName: "Operator",
    refundTime: "Waktu Pengembalian Dana",
    refundAmount: "Jumlah pengembalian dana (idr)",
    refundedAmount: "Jumlah yang dikembalikan (idr)",
    refundResultDesc: "Perkembangan Pengembalian Dana",
    time: "Waktu"
  },
  cancellation: {
    cardSerialNumber: "Nomor Transaksi",
    accountBalance: "Jumlah",
    tips:
      "Setelah pembatalan, jumlah yang ada di dalam kartu akan secara otomatis dikembalikan dan kartu pengisian daya tidak akan dapat digunakan.",
    success: "Berhasil Dibatalkan",
    successConfirm: "Apakah anda yakin ingin membatalkan akun?"
  },
  nonCardDetails: {
    cardInfo: "Informasi Kartu Listrik",
    remark: "Catatan",
    accountBalance: "Saldo Rekening (idr)",
    createUserName: "Pembuka Kartu",
    createTime: "Waktu Pembukaan Kartu",
    statusDesc: "Status Kartu Listrik"
  },
  nonRealNameCardManagement: {
    cardMember: "Member Kartu",
    cardStatus: "Status Kartu",
    inUse: "Sedang Digunakan",
    cancelled: "Dibatalkan",
    operationStatistics: "Statistik Operasi",
    selfSupport: "Milik Sendiri",
    generationCamp: "Dimiliki Oleh Tenant",
    fuzzySearch:
      "Nomor transaksi / nomor kartu listrik / nama kontak / telepon",
    cardAffiliation: "Pemilik Kartu",
    commercialTenant: "Tenant",
    cardNumber: "Nomor Kartu Listrik",
    cardPhysicalNumber: "Nomor seri kartu listrik",
    cardSerialNumber: "Nomor Transaksi",
    contacts: "Nama Kontak",
    phone: "Telepon",
    cardBalance: "Saldo Kartu (idr)",
    frozenAmount: "Jumlah yang dibekukan (idr)",
    openTime: "Waktu Buka",
    remark: "Catatan",
    money: "Jumlah Pembukaan Kartu",
    openCardTips:
      "Harap pastikan penerbit kartu terhubung ke komputer dan letakkan kartu pada pengirim kartu",
    openCardError:
      "Kartu pengisian daya telah digunakan. silakan gunakan kartu lain.",
    cardPhysicalNumberPl: "Masukkan nomor transaksi kartu",
    cardSerialNumberPl: "Silakan masukkan nomor seri",
    moneyPl: "Silakan masukkan jumlah isi ulang",
    moneyMax: "Jumlah satu kali pengisian ulang tidak boleh lebih dari 5000",
    moneyMin: "Jumlah isi ulang tidak boleh kurang dari 0",
    moneyError:
      "Jumlah pembukaan kartu harus berupa angka dengan tidak lebih dari dua angka desimal",
    openCardSuccess: "Kartu Berhasil Dibuka",
    balance: "Saldo",
    amount: "Jumlah",
    cancellation: "Batal",
    cancellationTips:
      "Setelah pembatalan, jumlah yang ada di dalam kartu akan secara otomatis dikembalikan dan kartu pengisian daya tidak akan dapat digunakan.",
    cancellationSuccess: "Berhasil Dibatalkan",
    accountBalance: "Saldo Rekening (idr)",
    createUserName: "Pembuka Kartu",
    createTime: "Waktu Buka",
    status: "Status Kartu",
    operationInfo: "Informasi Pengoperasian",
    cardInfo: "Informasi Kartu",
    cardDetails: "Rincian kartu nama bukan sebenarnya",
    remarkPl: "Silakan Masukkan Catatan",
    createName: "Operator",
    operateTime: "Waktu Operasi",
    operateType: "Operasi",
    rechargeAmount: "Jumlah isi ulang (idr)",
    allMoneyMax: "Jumlah maksimum kartu online tidak boleh melebihi 9999 idr",
    accountPkId: "Nomor Kartu Keanggotaan",
    refundAmount: "Jumlah pengembalian dana (idr)",
    refundBtn: "Pengembalian Dana",
    refundError: "Jumlah pengembalian dana tidak boleh melebihi saldo akun",
    refundSuccess: "Pengembalian Dana Berhasil",
    silkScreenNumber: "Nomer Sablon Cetak",
    getCard: "Kartu Baca",
    input: "Impor Secara Langsung",
    reset: "Atur Ulang",
    cardExist:
      "Kartu sudah ada. mohon batalkan atau gunakan kartu lain sebelum melakukan tindakan pembukaan",
    openCard: "Mengaktifkan Kartu",
    silkScreenNumberPl: "Silakan masukkan nomor sablon cetak",
    contactsPl: "Silakan masukkan nama kontak",
    cardYes: "Kartu Dapat Dioperasikan",
    logout: "Membatalkan Kartu",
    viewNo: "Browser anda tidak mendukung sistem penerbitan kartu",
    connectError: "Koneksi Penerbit Gagal",
    logoutSuccess: "Kartu Berhasil Dibatalkan",
    cardChange: "Kartu telah diubah. harap baca kembali kartu tersebut.",
    cardWhite: "Kartu ini kosong. silakan buka terlebih dahulu",
    statusError1: "Harap baca kartu terlebih dahulu",
    statusError2: "Kartu pengisian daya tidak terdeteksi. silakan coba lagi.",
    statusError3: "Kode pelanggan tidak boleh kosong",
    statusError4: "Jenis kartu tidak boleh kosong",
    statusError5: "Id tidak boleh kosong",
    statusError6: "Id kartu hanya boleh terdiri dari 16 digit",
    statusError7: "Tidak dapat beroperasi. kartu tidak ada dalam sistem. ",
    logoutTitle:
      "Operasi ini akan menghapus semua informasi dalam kartu ini. harap berhati-hati.",
    connectBtn: "Menghubungkan Penerbit Kartu",
    connectBtnLoading: "Penerbit Kartu Penghubung......",
    cardBind:
      "Kartu telah digunakan. harap ganti ke kartu yang tidak digunakan. nomor seri: ",
    relation: "Rekan",
    userName: "Nama Anggota",
    cardNumberPl: "Silakan masukkan nomor kartu",
    relationSuccess: "Berhasil Diasosiasikan",
    hasSms: "Kirim Sms",
    hasSmsPl: "Pilih apakah akan mengirim sms",
    word: "Tips: Petunjuk",
    wordDownload: "Klik di sini untuk mengunduh",
    no: "Tidak.",
    yes: "Ya.",
    cardConnectionFailed: "Sambungan ke penerbit kartu gagal",
    notSupport: "Browser anda tidak mendukung sistem penerbitan kartu"
  },
  cardTips: {
    t1: "1. unduh dan instal driver penerbit kartu",
    download: "Klik di sini untuk mengunduh",
    t1_1: "Untuk sistem windows xp, silakan",
    t2:
      "2. sambungkan pembaca kartu ke komputer melalui kabel usb. setelah dihidupkan, pembaca kartu akan mengeluarkan bunyi 'bip' dan led di dalam pembaca kartu akan berkedip.",
    t3: "3. unduh dan jalankan plug-in penerbit kartu (",
    t3_1: "), setelah menghubungkan pembaca kartu, klik 'buka layanan'.",
    t4: "4. buka manajemen penerbitan kartu pada browser untuk pengoperasian.",
    tips: "Catatan: ",
    tips1:
      "1. untuk saat ini hanya mendukung sistem windows dan versi seri windows 7 / 10.",
    tips1_1:
      "Jika anda ingin menggunakan dengan os windows xp, anda perlu menginstal framework net3.5",
    tips2:
      "2. selama proses berlangsung, pastikan plug-in penerbit kartu dalam status layanan terbuka.",
    tips3:
      '3. ketika muncul prompt "periksa apakah akan memasukkan pembaca kartu atau menginstal driver port serial", umumnya menunjukkan masalah bahwa pembaca kartu tidak dimasukkan atau driver port serial tidak diinstal. klik kanan "komputer saya" dan pilih "manajemen", lalu di jendela "manajemen komputer" yang muncul, klik "pengelola perangkat" di menu sebelah kiri, periksa apakah "port serial usb" atau "ft232rusr uart" ada di bawah "perangkat lain". jika tidak, berarti pembaca kartu tidak dicolokkan. coba usb lain untuk melakukannya lagi.'
  },
  addMerchant: {
    accountInfo: "Informasi Akun",
    info: "Informasi Dasar",
    fullName: "Nama Tenant",
    shortName: "Nama Singkatan",
    contacts: "Nama Kontak",
    contactsMail: "Email",
    telephone: "Telepon",
    address: "Alamat",
    operatorShare: "Saham Operator",
    shareType: "Jenis Saham",
    isMoneyRules: "Jumlah Tetap",
    isMoneyRulesShareMaxError:
      "Jumlah tetap tidak boleh lebih besar dari jumlah total saham",
    orderTotalMoney: "Jumlah total setiap pesanan",
    orderTotalMoneyMax: "฿",
    orderShare: "Saham dari setiap pesanan",
    isMoneyRulesTips:
      "Menampilkan jumlah bagian yang sesuai berdasarkan jenis pembagian. jenis pembagian dapat dipilih lebih dari satu.\r\n\r\ncatatan: setelah jumlah tetap dipilih, jumlah total tidak dapat dipilih pada saat yang sama untuk setiap pesanan",
    isPercentageRules: "Persentase",
    order: "Setiap Pesanan",
    cashConfig: "Pengaturan Penarikan Dana",
    cashMin: "Jumlah Penarikan Minimum",
    condition: "Kondisi",
    fromValueTips: "Jumlah Penyelesaian Melebihi",
    feeTips: "Mengurangi Biaya Transfer",
    feeTipsPl: "Potong biaya transfer sesuai persentase ",
    loginUrl: "Alamat Login",
    addTitle: "Tambahkan Nomor Rekening",
    resetPassword: "Atur ulang kata sandi",
    mchCollectionInfo: "Informasi Penerimaan Tenant",
    bankAccountName: "Nama Rekening Bank",
    bankDeposit: "Bank untuk pembukaan rekening penerima",
    bankAccountNo: "Rekening Bank Penerima",
    addMch: "Tambahkan Tenant",
    loginTitle: "Tambahkan Akun Masuk",
    updataTitle: "Ubah Akun Masuk",
    required: "Diperlukan",
    textLenMax: "Panjang tidak boleh melebihi",
    divisionPercentPl: "Silahkan pilih jenis pembagian",
    divisionPercentMax: "Rentang nilai: 0.00 ~ 100",
    divisionPercentError: "Masukkan nomor yang valid",
    base2: "Persentase",
    minWithdrawAmount: "Jumlah Penarikan Minimum",
    bankDepositPl:
      "Silakan masukkan nama bank untuk pembukaan rekening penerima",
    bankAccountNamePl: "Masukkan nama akun penerima",
    userName: "Nama Pengguna Masuk",
    effectiveTime: "Waktu Efektif",
    expireTime: "Masa Berlaku",
    accountName: "Nama Akun",
    bankInstitutionDesc: "Nama Bank",
    remarks: "Catatan",
    delConfig: "Apakah anda yakin ingin menghapus akun saat ini?",
    userParamsNull: "Akun pengguna yang login tidak boleh kosong",
    isPercentageRulesPl: "Pilih Jenis Persentase",
    isPercentageRulesError: "Jenis persentase tidak dapat diulang",
    addSuccess: "Berhasil Ditambahkan",
    mchLoginInfo: "Informasi Login Tenant",
    userParamsMax: "Hanya boleh ada satu pengguna yang masuk",
    mchDetails: "Detail Tenant",
    upDetails: "Ubah Tenant",
    add: "Tambahkan",
    rolePkIdPl: "Silakan Pilih Peran",
    expireTimePl: "Pilih tanggal efektif terlebih dahulu",
    expireTimeError: "Tidak boleh lebih awal dari tanggal efektif",
    userNameError: "Nama pengguna sudah ada",
    issueCardCode: "Kode Pelanggan",
    userPwd: "Kata Sandi",
    confirmPassword: "Konfirmasi Kata Sandi",
    amountType: "Biaya listrik per pesanan",
    amountType2: "Biaya layanan per pesanan",
    amountType3: "Biaya kelebihan waktu per pesanan",
    cooperationTime: "Batas Waktu Kerjasama",
    currentPassword: "Kata sandi saat ini"
  },
  upSafePassword: {
    userPwd: "Kata Sandi Baru",
    confirmPassword: "Ulangi kata sandi baru",
    verCode: "Kode Verifikasi",
    verCodePl: "Kode verifikasi tidak boleh kosong",
    userPwdPl: "Kata sandi tidak boleh kosong",
    userPwdLen: "Panjang kata sandi adalah 6-18",
    userPwdError:
      "Kata sandi tidak boleh mengandung spasi, tab, atau jeda baris",
    confirmPasswordPl: "Kata sandi konfirmasi tidak boleh kosong",
    confirmPasswordError: "Kata sandi tidak cocok",
    upError: "Modifikasi Gagal",
    upSuccess: "Kata sandi berhasil diubah。 silakan masuk lagi"
  },
  commonTableName: {
    cardNo: "Nomor Kartu",
    insideOrderNo: "Nomor Transaksi",
    externalOrderNo: "Pesanan Eksternal",
    orderStatus: "Status Pesanan",
    orderType: "Jenis Pesanan",
    no: "Tidak.",
    yes: "Ya.",
    details: "Detail",
    endOrder: "Tutup Pesanan",
    error: "Penanganan Pengecualian",
    orderNo: "Nomor Pesanan",
    merchantName: "Nama Tenant",
    netSystemName: "Operator Mitra",
    orderStatusDesc: "Status Pesanan",
    staName: "Stasiun",
    pileName: "Nama Charger",
    gunName: "Nama Konektor",
    serialNumber: "Nomor Charger",
    memberName: "Nama Anggota",
    phoneNo: "Telepon",
    carNo: "Plat Nomor",
    chargeBeginTime: "Waktu mulai pengisian daya",
    chargeEndTime: "Akhiri waktu pengisian daya",
    payTime: "Waktu Pembayaran",
    chargeDuration: "Durasi",
    delayDuration: "Waktu Tunda",
    chargeElect: "Daya Keluaran (kwh)",
    chargeAmount: "Biaya Listrik (idr)",
    serviceAmount: "Biaya Layanan (idr)",
    time: "Waktu",
    delayAmount: "Biaya kelebihan waktu (idr)",
    totalAmount: "Jumlah Total (idr)",
    discountAmount: "Jumlah Diskon (idr)",
    transactionAmount: "Jumlah yang dibayarkan (idr)",
    startSoc: "Mulai Soc",
    endSoc: "Akhir Soc",
    stopReason: "Alasan Berhenti",
    orderSource: "Sumber Pesanan",
    abnormalType: "Ketidaknormalan",
    elecPrice: "Tarif Listrik (idr/kwh)",
    servicePrice: "Tarif Layanan (idr/kwh)",
    slotFlag: "Jenis Biaya Listrik",
    slotElecPrice: "Harga Listrik (idr)",
    delayMins: "Durasi (menit)",
    delayFreeMins: "Rentang waktu bebas (menit)",
    sex: "Jenis Kelamin",
    vipType: "Jenis Anggota",
    vin: "Kode Vin",
    cardType: "Model Mobil",
    staType: "Jenis Situs",
    staStatus: "Status Situs",
    staAddr: "Alamat Situs",
    gunPkId: "Nomor Konektor",
    manufacturer: "Milik Produsen",
    deviceType: "Type Charger",
    devicemodel: "Model Peralatan",
    ratedPower: "Daya Terukur (kw)",
    ratedCurrent: "Nilai Arus",
    ratedVoltage: "Nilai Tegangan",
    timeInterval: "Rentang Waktu",
    chargeDiscount: "Diskon Listrik",
    serviceDiscount: "Diskon Biaya Layanan",
    delayDiscount: "Diskon biaya kelebihan waktu",
    totalDiscount: "Jumlah Total Diskon",
    chargeTransAmount: "Biaya listrik berbayar (idr)",
    serviceTransAmount: "Biaya layanan berbayar (idr)",
    jian: "Tajam",
    feng: "Puncak",
    ping: "Datar",
    gu: "Lembah",
    beforeBalance: "Saldo sebelum pembayaran (idr)",
    afterBalance: "Saldo setelah pembayaran (idr)",
    reteInfo: "Informasi Harga",
    charge: "Waktu Pengisian Daya",
    startTime: "Waktu Mulai",
    endTime: "Waktu Berakhir",
    modifyTime: "Waktu Pembaruan",
    staPkId: "Stasiun Id",
    entUserName: "Nama Perusahaan",
    chargingCard: "Nomor Kartu Pengguna",
    chargingMode: "Metode Pengisian Daya",
    userType: "Jenis Pengguna",
    stationRegion: "Area Stasiun",
    cardNameOrMemberName: "Nama Kartu/nama Kontak",
    memberType: "Jenis Member"
  },
  orderList: {
    orderSource1: "Pesanan Online",
    orderSource2: "Pesanan Offline",
    exportType: "Default",
    exportType2: "Detail",
    end: "Pengisian Daya Berakhir",
    endConfirm: "Apakah anda yakin ingin menutup order?",
    endLoadingTips: "Mengeluarkan perintah berhenti mengisi daya",
    endLoadingTips2:
      'Sistem akan mengeluarkan perintah berhenti mengisi daya ke pengisi daya. jika status pesanan tidak dapat diubah menjadi "pengisian daya selesai" dalam waktu 15 detik, langkah kedua akan dilakukan',
    endLoadingTips3: "Menghasilkan laporan pengisian platform",
    endLoadingTips4:
      'Sistem akan mengirimkan laporan pengisian daya platform ke pengisi daya. jika status pesanan tidak dapat diubah menjadi "pengisian daya selesai" dalam waktu 15 detik, langkah ketiga akan dilakukan',
    endLoadingTips5: "Mengubah status pesanan menjadi tidak normal",
    endLoadingTips6:
      "Sistem akan memodifikasi pesanan ini sebagai tidak normal, dan pengguna dapat melakukan tindakan pengisian daya berikutnya secara normal",
    endLoading: "Memproses..",
    endCharge: "Akhiri Pengisian Daya",
    loadingSuccess: "Perintah berhenti berhasil dikeluarkan",
    success: "Laporan platform berhasil dibuat",
    orderError: "Status pesanan berubah menjadi tidak normal",
    endSuccess: "Berakhir Diakhiri",
    pageTitle: "Pesanan Pengisian Daya",
    totalChargeElect: "Total listrik yang dibebankan (kwh)",
    totalTransactionAmount: "Total pendapatan aktual (idr)",
    totalServiceAmount: "Biaya Layanan (idr)",
    totalChargeAmount: "Biaya Listrik (idr)",
    totalDelayAmount: "Biaya kelebihan waktu (idr)",
    totalDiscount: "Total Diskon (idr)",
    totalServiceDiscount: "Diskon biaya layanan (idr)",
    totalChargeDiscount: "Diskon biaya listrik (idr)"
  },
  abnormalOrder: {
    pileCharging: "Tagihan pengisi daya (idr)",
    chargeTime: "Durasi Pengisian Daya",
    stopReason: "Alasan Untuk Berhenti",
    pileChargeAmount: "Tagihan total pengisi daya (idr)",
    sysCharging: "Penagihan Platform (idr)",
    sysChargeAmount: "Tagihan total platform (idr)",
    pileErrorValue: "Selisih nilai dengan penagihan pengisi daya:",
    normalErrorValue:
      "Selisih normal: kurang dari 0,5 idr atau persentase selisih kurang dari 20%",
    usePileCharging: "Gunakan tagihan pengisi daya",
    useSysCharging: "Gunakan Penagihan Platform",
    useInputharging: "Masukan jumlah secara manual",
    amountPayable: "Jumlah Terhutang (idr)",
    countType:
      "Rumus perhitungan: total tagihan pengisi daya / (total tagihan platform + total biaya kelebihan waktu)",
    payAmount: "Total Pembayaran (idr)"
  },
  orderDetails: {
    aorderDetailsTitle: "Detail pesanan pengisian daya",
    chargeType: "Jenis Pengisian Daya",
    chargeStatus: "Status Pengisian Daya",
    chargingModel: "Strategi Pengisian Daya",
    chargeElect: "Daya listrik yang dibebankan (kwh)",
    chargeDuration: "Durasi Pengisian Daya",
    orderCheckDetails: "Detail Verifikasi Pesanan",
    chargeDataEchart: "Data Pengisian Daya",
    chargeMoneyEchart: "Bagan garis penagihan pengisian daya",
    batteryEchart: "Bagan garis data baterai",
    faultCode: "Kode Pengecualian",
    faultName: "Nama Pengecualian",
    faultDesc: "Deskripsi Pengecualian",
    userInfo: "Info Pengguna",
    siteInfo: "Info Situs",
    siteId: "Id Situs",
    pileInfo: "Info Pengisi Daya",
    rateInfo: "Info Biaya",
    errorHandle: "Penanganan Pengecualian",
    billingMethod: "Metode Penagihan",
    operationTime: "Waktu Operasi",
    operationoOject: "Objek Operasi",
    insertGun: "Masukkan Konektor",
    startCharging: "Mulai Mengisi Daya",
    endCharging: "Akhiri Pengisian Daya",
    draw: "Cabut Steker",
    outputVoltage: "Tegangan Keluaran",
    chargingPower: "Daya Pengisian",
    outputCurrent: "Arus Keluaran",
    demandVoltage: "Tegangan Permintaan",
    demandCurrent: "Arus Permintaan",
    cpVoltage: "Tegangan Cp",
    chargerTemperature: "Suhu Pengisi Daya",
    gunTemperature: "Suhu Konektor",
    brmProtocol: "Versi Protokol Brm",
    brmBatteryType: "Jenis Baterai Brm",
    brmBatteryCapacity: "Kapasitas terukur baterai brm",
    brmRatedVoltage: "Tegangan total terukur brm",
    BCPMaxVoltage: "Tegangan maksimum unit bcp",
    BCPMaxCurrent: "Arus Maksimum Bcp",
    BCPBatteryEnergy: "Energi total baterai bcp",
    BCPMacVoltage: "Tegangan pengisian daya maksimum bcp",
    BCPMaxTemperature: "Suhu Maksimum Bcp",
    BCPStartSOC: "Bcp Memulai Soc",
    BSMMaxTemperature: "Suhu sel daya maksimum bsm",
    BCSMaxBatteryVoltage: "Tegangan sel tunggal maksimum bcs"
  },
  offCardOrder: {
    cardPhysicalSn: "Nomor Seri",
    cardSn: "Nomor Kartu Fisik",
    chargeMode: "Mode Pengisian Daya",
    dealType: "Status Pesanan",
    exportName: "Pemesanan kartu secara offline",
    dl: "Daya listrik yang dibebankan (kwh)",
    amount: "Pendapatan (idr)",
    service: "Biaya Layanan (idr)",
    chargingTime: "Durasi Pengisian Daya",
    orderNumber: "Jumlah Pesanan (unit)",
    offCardNum: "Jumlah Kartu Offline",
    chargingType: "Mode Pengisian Daya"
  },
  offCardOrderDetails: {
    pageTitle: "Mengisi Detail Pesanan"
  },
  operationData: {
    activeNum: "Pengguna Aktif",
    orderCount: "Jumlah Pesanan (unit)",
    chargeHours: "Durasi Pengisian Daya (h)",
    totalElec: "Daya listrik yang dibebankan (kwh)",
    serviceAmount: "Biaya Layanan (idr)",
    todayData: "Data Hari Ini",
    todayTotalAmount: "Pendapatan Hari Ini",
    todayOrderCount: "Pesanan Hari Ini",
    todayTotalElec: "Listrik yang dibebankan hari ini",
    todayActiveNum: "Pengguna aktif hari ini",
    todayDuration: "Duration Today",
    assets: "Informasi Aset",
    noStaPkId: "Silakan Pilih Stasiun",
    modalTab: "Bagan",
    modalTab2: "Tabel",
    fullName: "Nama Anggota",
    phoneNo: "Telepon",
    createTime: "Waktu Pendaftaran",
    balanceAmount: "Saldo Rekening (idr)",
    chargeTimes: "​Charging Orders(times)",
    staDataChartTitle: "Statistik stasiun pengisian daya",
    yAxisName: "Kwh / Idr",
    staDataDl: "Total Listrik",
    staDataAmount: "Jumlah Total",
    pileChartTitle: "Pengisi Daya",
    pileChartAc: "Pengisi Daya Ac",
    pileChartDc: "Pengisi Daya Dc",
    pileTitle: "Data Aset"
  },
  alarmEvent: {
    alarmTime: "Waktu Alarm",
    eventAmount: "Total Kejadian",
    todayEvent: "Peristiwa Hari Ini",
    alarmRatio: "Rasio Alarm",
    alarmLevel: "Tingkat Alarm",
    alarmType: "Jenis Alarm",
    alarmLevelProporsional: "Rasio Tingkat Alarm",
    alarmTypeProporsional: "Jenis Alarm - Proporsional",
    equipmentAlarmAmountTop5: "Alarm Kesalahan Perangkat TOP5",
    stationAlarmAmountTop5: "Alarm Stasiun Top5",
    equipmentSn: "Perangkat SN",
    stationName: "Stasiun",
    quantity: "Berapa Kali",
    faultDesc: "Deskripsi Acara",
    recoverTime: "Waktu Pemulihan",
    duration: "Durasi Penyelesaian Masalah",
    alarmStatus: "Status Saat Ini",
    equipmentType: "Jenis Perangkat"
  },
  siteMonitor: {
    province: "Provinsi",
    city: "Kota",
    type: "Jenis",
    power: "Daya",
    equipmentAmount: "Jumlah Peralatan",
    gun: "Konektor",
    number: "Nomor",
    voltage: "Tegangan",
    current: "Arus",
    chargeElect: "Listrik",
    totalPower: "Biaya Kumulatif",
    thisPower: "Arus Keluaran",
    setPower: "Mengatur Daya Keluaran",
    totalTimes: "Waktu pengisian daya kumulatif",
    totalHours: "Durasi pengisian daya kumulatif",
    accountPkId: "Akun Pengisian Daya",
    accountType: "Jenis Akun",
    carVin: "Vin Kendaraan",
    chargedMinutes: "Durasi Pengisian Daya",
    chargingPower: "Daya listrik yang dibebankan (kwh)",
    predictAmount: "Jumlah Biaya (idr)",
    faultInfo: "Informasi Kerusakan",
    orderDetails: "Rincian Pesanan"
  },
  pileInfo: {
    operationType: "Jenis Operasi",
    staStatus: "Status Operasi",
    pileList: "Daftar Pengisi Daya"
  },
  pileInfoDetail: {
    city: "Kota",
    staAddress: "Alamat",
    position: "Lokasi Konstruksi",
    staLat: "Bujur Dan Lintang",
    staTypeName: "Jenis Situs",
    fullName: "Tenant Terkait",
    tagInfoVos: "Tag Situs",
    commissioningDate: "Waktu Komisioning",
    businessBeginHours: "Waktu Buka",
    parkNum: "Jumlah Tempat Parkir",
    serviceTel: "Nomor Telepon Layanan",
    phoneNo: "Nomor Telepon Situs",
    hasFreePark: "Apakah biaya parkir gratis",
    yes: "Ya.",
    no: "Tidak.",
    remarks: "Tips",
    feeName: "Tarif Situs",
    DC: "Pengisi Daya Dc",
    AC: "Pengisi Daya Ac",
    oprDelayFeeInfos: "Biaya Kelebihan Waktu",
    delayFreeMinutes: "Durasi Gratis",
    staPics: "Gambar Situs",
    staInfo: "Informasi Pengisi Daya",
    totalDev: "Total Peralatan",
    dcGunCount: "Muzzle pengisi daya dc",
    acGunCount: "Muzzle pengisi daya ac",
    tab1: "Detail Situs",
    tab2: "Catatan Pemeliharaan",
    tab3: "Pembaruan Nilai",
    price: "Total Harga (idr/kwh)",
    manufacturerName: "Produsen Peralatan",
    ratedPower: "Nilai Daya (kw)",
    delayUnit: "Idr / Menit",
    reason: "Alasan",
    debuggingPeople: "Personel Debugging",
    debuggingContent: "Konten Debugging",
    oldFeeName: "Tarif Lama",
    newFeeName: "Tarif Baru",
    replaceTime: "Tanggal Perubahan"
  },
  pileInfoEle: {
    addRateBtn: "Tambahkan Templat Tarif",
    upRateBtn: "Ubah Templat Tarif",
    delRateBtn: "Menghapus Templat Tarif",
    rateTpl: "Templat Nilai",
    feeName: "Nama Templat",
    feeNamePl: "Silakan masukkan nama templat",
    acRate: "Tingkat pengisi daya ac",
    dcRate: "Tingkat pengisi daya dc",
    delayRate: "Tingkat Penundaan",
    delayFreeMinutes: "Durasi Gratis (menit)",
    rate: "Tarif",
    elePriceList: "Daftar Harga Listrik",
    slotFlag: "Jenis Harga Listrik",
    slotElecPrice: "Harga Listrik (idr/kwh)",
    slotServicePrice: "Biaya Layanan (idr/kwh)",
    time: "Slot Waktu",
    slotDelayPrice: "Tarif (idr/menit)",
    delRateConfirm: "Apakah anda yakin untuk menghapus harga listrik saat ini?",
    ratePl: "Silakan Pilih Tarif"
  },
  pileList: {
    batchStaBtn: "Asosiasi kelompok / lepaskan ikatan",
    batchLineBtn: "Batch online / offline",
    addBtn: "Menambahkan info pengisi daya",
    deviceStatus: "Status Charger",
    showQcode: "Kode Qr",
    editGun: "Edit Konektor",
    showUnlock: "Membuka Kunci",
    offLine: "Offline",
    showFee: "Mengeluarkan Harga Listrik",
    outPile: "Lepaskan Pengisi Daya",
    unbind: "Lepaskan Ikatan",
    downQCode: "Masalah",
    staName: "Situs",
    internalNumber: "Nomor Seri",
    chargeGunInfoVoList: "Model Konektor",
    parkNo: "Nomor Parkir",
    gunStatus: "Status Konektor",
    editPile: "Edit Pengisi Daya",
    issueSuccess: "Kode qr berhasil diterbitkan",
    showFeeConfirm: "Apakah anda yakin untuk mengeluarkan harga listrik?",
    showFeeSuccess: "Harga listrik berhasil diterbitkan",
    showUnlockConfirm: "Apakah anda yakin untuk membuka kunci?",
    showUnlockSuccess: "Berhasil Membuka Kunci",
    unbindSuccess: "Situs Berhasil Dilepaskan",
    moveInSta: "Stasiun Tujuan",
    moveInStaPl: "Silakan Pilih Stasiun",
    remarks: "Catatan"
  },
  addPile: {
    deviceType: "Jenis Peralatan",
    deviceModelPkId: "Model Peralatan",
    protocolPkId: "Perjanjian",
    remark: "Catatan",
    gunInfo: "Info Muzzle",
    info: "Informasi",
    addName: "Tambahkan Pengisi Daya",
    staNamePl: "Situs Harus Dipilih",
    deviceTypePl: "Jenis perangkat harus dipilih",
    deviceModelPkIdPl: "Model peralatan harus dipilih",
    sn: "Nomor Pengisi Daya",
    snPl: "Nomor pengisi daya tidak boleh kosong",
    snPl2: "Nomor pengisi daya harus berupa angka",
    snPl3: "Nomor pengisi daya harus berupa angka atau huruf",
    pileNamePl: "Nama pengisi daya tidak boleh kosong",
    deviceStatusPl: "Status operasi tidak boleh kosong",
    protocolPkIdPl: "Pilih kunci utama perjanjian",
    qrcode: "Kode Qr",
    detailsName: "Detail Pengisi Daya",
    updataName: "Edit Pengisi Daya",
    charging: "Pengisian Daya",
    inserted: "Konektor Terpasang",
    fault: "Malfuction",
    disable: "Nonaktifkan",
    offLine: "Offline",
    free: "Gratis",
    full: "Penuh",
    subscribe: "Memesan",
    offline: "Offline",
    online: "Online"
  },
  splitSettlement: {
    shareSettlement: "Penyelesaian Pembagian Saham",
    orderBreakdown: "Rincian Pesanan",
    merchantName: "Nama Tenant",
    chargingOrderNumber: "Nomor pesanan pengisian daya",
    selectionTime: "Pilih Waktu",
    chargingStation: "Stasiun",
    chargeVolume: "Daya listrik yang dibebankan (kwh)",
    electricityBill: "Biaya Listrik (idr)",
    serviceCharge: "Biaya Layanan (idr)",
    chargeableAmount: "Jumlah yang harus dibayar (idr)",
    discountAmount: "Jumlah Diskon (idr)",
    totalAmountActuallyPaid: "Jumlah pembayaran aktual (idr)",
    partitionMethod: "Mode Berbagi",
    merchantIncome: "Pendapatan Tenant",
    operatorShare: "Saham Operator",
    orderDate: "Tanggal Pemesanan",
    orderTimeError:
      "Waktu pemesanan tidak boleh kosong. silakan pilih waktu yang benar.",
    errorStartTimeEndTime:
      "Waktu mulai tidak boleh lebih lambat dari waktu akhir",
    contentConfirm: "Apakah anda yakin ingin memilih data saat ini?",
    successfulOperation: "Berhasil",
    daySettlementOrderNumber: "Nomor Laporan Harian",
    dailyStatementStatus: "Status Laporan Harian",
    settlementDate: "Tanggal Penyelesaian",
    numberOfOrders: "Jumlah Pesanan (unit)",
    actualChargeAmount: "Jumlah pembayaran aktual (idr)",
    merchantIncomeAmount: "Jumlah bagian Tenant (idr)",
    operatorShareAmount: "Jumlah saham operator (idr)",
    createTime: "Tanggal Pembuatan",
    pleaseSelectTheGenerationDate: "Pilih Tanggal Pembuatan",
    createTimeError:
      "Waktu mulai dari tanggal pembuatan tidak boleh lebih lambat dari waktu akhir",
    selectMonth: "Pilih bulan penyelesaian bulanan",
    confirmDate: "Apakah anda yakin untuk memilih data saat ini?",
    confirmGeneration: "Apakah anda yakin untuk membuat ulang data?",
    withdrawnDate: "Apakah anda yakin ingin menarik data yang dipilih?",
    selectDate:
      "Apakah anda yakin untuk melakukan tindakan pada data yang dipilih?",
    selectDateToOperate: "Pilih data untuk melakukan tindakan",
    deleteTitle: "Alasan Pembatalan",
    remarkPl: "Silakan Masukkan Alasannya",
    supplement: "Suplemen",
    orderNo: "Pilih nomor laporan harian",
    orderNoPl: "Silakan Pilih Pesanan",
    staName: "Stasiun Pengisian Daya",
    settlementStatus: "Status Akuntansi",
    regenerate: "Regenerasi",
    allSettlement: "Akuntansi Batch",
    settlement: "Akuntansi",
    errorInfo: "Info Tidak Normal",
    accountingRecords: "Catatan Akuntansi",
    accountingRecordsStatus: "Status Akuntansi",
    accountingRecordsRepairStatus: "Status Perbaikan",
    accountingRecordsTime: "Tanggal Penyelesaian",
    initialAccounting: "Akuntansi Awal",
    newAccounting: "Akuntansi Terbaru",
    ComparisonResults: "Perbedaan Hasil Perbandingan",
    voidPl: "Pilih pernyataan yang akan dibatalkan",
    voidSuccess: "Pernyataan Berhasil Dibatalkan",
    auditOrderPl: "Pilih pernyataan yang akan ditinjau",
    auditOrder: "Pernyataan Tinjauan",
    auditOrderSuccess: "Pernyataan Berhasil Ditinjau",
    auditOrderConfirm:
      "Tidak dapat dibatalkan setelah ditinjau. silakan lanjutkan dengan hati-hati"
  },
  withdrawal: {
    dataTitle1: "Jumlah yang akan ditarik (idr)",
    dataTitle2: "Jumlah yang ditarik (idr)",
    withdrawOrderStatus: "Status Pesanan Penarikan",
    createTime: "Tanggal Pembuatan",
    reviewDate: "Tanggal Peninjauan",
    withdrawOrderTemplate: "Templat pesanan penarikan dana",
    withdrawOrderNumber: "Menarik Nomor Pesanan",
    withdrawalAmount: "Jumlah Penarikan",
    transferFee: "Biaya Layanan",
    actualWithdrawalAmount: "Jumlah Penarikan Aktual",
    withdrawalAdd: "Tambahkan Pesanan Penarikan",
    preview: "Pratinjau",
    resubmit: "Kirim Ulang",
    withdraw: "Mencabut",
    annex: "Lampiran",
    transferAmount: "Jumlah Penarikan Aktual",
    completeTime: "Tanggal Penyelesaian Penarikan",
    orderStatusDesc: "Status Pesanan Penarikan",
    withdrawWithdrawal: "Mencabut perintah penarikan dana",
    withdrawWithdrawalConfirm:
      "Apakah anda yakin untuk mencabut perintah penarikan dana?",
    withdrawWithdrawalSuccess: "Perintah penarikan berhasil dicabut"
  },
  withdrawalTemplate: {
    orderNo: "Nomor Pesanan Penarikan",
    order: "Perintah Penarikan",
    payee: "Penerima",
    payer: "Pembayar",
    remarks: "Keterangan",
    remarks1:
      "1. jumlah pembayaran dihasilkan oleh aplikasi operator, yang digunakan oleh pelanggan untuk mengisi daya di stasiun pengisian daya merchant.",
    remarks2:
      "2. jumlah penarikan aktual = jumlah penarikan periode berjalan - biaya transfer;",
    remarks3: "3. biaya transfer adalah biaya layanan transfer offline;",
    cashExplain: "Instruksi Penarikan Dana",
    cashExplain1:
      "1. setelah tagihan diverifikasi sebagai benar, pemohon harus mengirimkan tagihan ke perusahaan pembayar melalui pos atau email setelah distempel dan dikonfirmasi. perusahaan pembayar akan menyelesaikan transfer publik atau pribadi secara offline dalam waktu 3-5 hari kerja setelah diterima.",
    cashExplain2:
      "2. dengan menandatangani dan mencap, anda menyetujui penyelesaian penarikan ini.",
    cashMch: "Tenant Penarikan (berstempel):",
    sign: "Tanda tangan perwakilan yang berwenang:",
    time: "Tanggal:",
    download: "Unduh Sertifikat",
    cashInfo: "Informasi Penarikan Dana",
    merchantName: "Tenant Penarikan",
    staNameList: "Stasiun Pengisian Daya",
    previousBalance: "Saldo setelah penarikan periode sebelumnya",
    totalAmount: "Jumlah penarikan dalam periode berjalan",
    serviceCharges: "Biaya Layanan Transfer",
    transferAmount: "Jumlah Penarikan Aktual",
    collectionInfo: "Informasi Penerimaan",
    mchContactPerson: "Nama Kontak Tenant",
    mchPhoneNumber: "Telepon Tenant",
    bankAccountName: "Nama Perusahaan",
    collectionAcc: "Akun Penerima",
    bankDeposit: "Bank Pembuka",
    bankAccountNo: "Nomor Rekening Penerima",
    payerInfo: "Informasi Pembayar",
    oprName: "Nama Pembayar",
    contacts: "Nama Kontak",
    telephone: "Nomor Kontak",
    invoiceType: "Jenis Faktur",
    openInfo: "Informasi Faktur",
    companyName: "Nama Perusahaan",
    taxId: "Nomor Identifikasi Pajak",
    payerBankAccountNo: "Akun",
    registerAddress: "Alamat Pengiriman",
    no: "Tidak Ada Data"
  },
  withdrawFormAdd: {
    pageAdd: "Tambahkan Pesanan Penarikan",
    pageUpdata: "Kirim ulang pesanan penarikan dana",
    invoiceType: "Membuat faktur atau tidak",
    totalAmount: "Jumlah Penarikan",
    availableAmount: "Jumlah yang dapat ditarik",
    allWithdraw: "Tarik Semua",
    minWithdraw: "Jumlah Penarikan Minimum",
    serviceCharges: "Biaya Layanan Transfer",
    transferAmount: "Jumlah Penarikan Aktual",
    collectionInfo: "Informasi Penerimaan",
    bankAccountName: "Nama Akun",
    bankDeposit: "Bank Pembuka",
    bankAccountNo: "Nomor Rekening Bank",
    amountNullPl: "Silakan masukkan jumlah penarikan",
    amountErrorPl:
      "Jumlah penarikan harus lebih besar dari 0 dan tidak lebih dari dua angka desimal",
    amountMin: "Jumlah penarikan tunggal tidak boleh kurang dari",
    amountMax: "Jumlah penarikan tidak boleh melebihi jumlah yang dapat ditarik"
  },
  header: {
    out: "Keluar",
    outConfirm: "Apakah anda yakin ingin keluar?",
    order: "Perintah pengecualian yang tertunda",
    goClick: "Klik Untuk Melewati",
    unit: "Entri",
    outTime: "Login telah kedaluwarsa. silakan masuk lagi."
  },
  cashTopUp: {
    cashTopUp: "Cash Top-up",
    topUp: "Top Up",
    orderNo: "Top-up Number",
    userName: "Nama Pengguna",
    phone: "Telepon",
    email: "Email",
    transactionTime: "Waktu Isi Ulang",
    userEmail: "Email Pengguna",
    userPhone: "Telepon Pengguna",
    amount: "Amount",
    amountTip: "Masukkan nomor top-up amount",
    topUpConfirmation: "Konfirmasi Cash Top-up",
    topUpAmount: "Top-up Amount",
    topUpAmountUnit: "Top-up Amount (idr)",
    confirmUserTip: "Konfirmasikan isi ulang untuk pengguna ini",
    accountDoesNotExist:
      "Silahkan proses top-up pembayaran cash anda ke tenant terdekat."
  },
  feedback: "Feedback",
  language: "Language",
  saveFailed: "Penyimpanan Gagal",
  emailBandTips:
    "Alamat email ini sudah terhubung ke kartu pengisian daya. Setiap email hanya bisa dihubungkan ke satu kartu.",
  emailNoRegTips:
    "Alamat email ini belum terdaftar. Silakan konfirmasi apakah akan didaftarkan sebagai pengguna aplikasi."
};
